import { Routes } from '@angular/router';
import { authGuard } from '@guards/auth.guard';
import { hasPermissionsGuard } from '@guards/has-permissions.guard';
import { ChangelogPage } from './changelog/changelog.component';
import { hasRoleGuard } from '@guards/has-role.guard';

let moduleName = 'app';

export const app: Routes = [
  {
    path: `${moduleName}/changelog`,
    component: ChangelogPage,
    title: 'Historial de cambios en la plataforma.',
    canActivate: [authGuard, hasRoleGuard(['SUPERUSER'])],
  },
];
